import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';

import { Spinner } from '../Spinner';
import { KhPageProps } from '../KhPage.interface';
import { cnKhPage } from '../KhPage.cn';

import './KhPage_loading.css';

export interface WithLoading {
    loading?: boolean;
}

export const withLoading = withBemMod<WithLoading, KhPageProps>(
    cnKhPage(),
    { loading: true },
    (Page): FC<WithLoading & KhPageProps> => (
        (props: WithLoading & KhPageProps): ReactElement => {
            const replacer = <Spinner />;

            return (
                <Page
                    {...props}
                    replacer={replacer}
                />
            );
        }
    ),
);
